import styled from "styled-components";
import { Device, Color } from "@styles/constants";
import { XSmallBodyMediumCSS } from "@styles/typography";

export const Container = styled.aside`
  position: absolute;
  top: 0;
  left: 0;
  width: 130px;
  height: 100%;
  z-index: 2;
  pointer-events: none;
  display: flex;
  align-items: center;

  @media ${Device.largeUp} {
    background: ${Color.blackBrand};
  }
`;

export const StickyMobile = styled.aside`
  position: relative;
  width: 100%;
  height: 48px;
  background: ${Color.blackBrand};
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ListButtonMobile = styled.a`
  display: flex;
  align-items: center;
  color: ${Color.white};
  text-decoration: none;
  pointer-events: all;

  &:hover {
    color: ${Color.white};
  }

  svg {
    width: 10px;
    height: 10px;
    margin-right: 4px;
    fill: ${Color.white};
  }
`;

export const ListButton = styled.a`
  display: block;
  width: 100%;
  color: ${Color.white};
  cursor: pointer;
  text-align: center;
  text-decoration: none;
  pointer-events: all;

  &:hover {
    color: ${Color.white};
  }

  span {
    ${XSmallBodyMediumCSS}
    display: block;
    margin: 0 auto;
    max-width: 14ch;
  }
`;

export const ListButtonSVG = styled.div`
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: ${Color.white};
  display: grid;
  place-content: center;
  margin: 10px auto 0;

  svg {
    margin-left: 2px;
    width: 10px;
    height: 10px;
    fill: ${Color.blackBrand};
  }
`;

export const Back = styled.div`
  position: sticky;
  top: calc(var(--banner-height) + var(--header-height) + 20px);
  margin-left: 1.25rem;

  @media ${Device.mediumUp} {
    margin-left: 2.5rem;
  }

  @media ${Device.largeUp} {
    margin-left: 60px;
  }
`;
